import createReactAngularDirective from '../../lib/createReactAngularDirective';
import { Items } from '../../react-components/Items';

export default createReactAngularDirective({
  Component: Items,
  directiveName: 'items',
  withProvider: true,
});
